export default __webpack_public_path__ + "618e8554030ede8887e6c89760fba474.webp";